import santaIsabel from '../assets/icons/clinicas/CentroMedicoSantaIsabel.svg'
import clinicaDelSol from '../assets/icons/clinicas/ClinicaDelSol.svg'
import bazterrica from '../assets/icons/clinicas/CentroMedicoBazterica.svg'
import santaRita from '../assets/icons/clinicas/CentroMedicoSantaRita.svg'
import clinicaSantaIsabel from '../assets/icons/clinicas/ClinicaSantaIsabel.svg'
import clinicaBazterrica from '../assets/icons/clinicas/ClinicaBazterrica.svg'

const CENTERS = {
	santaIsabel: {
		name: 'Centro Médico Santa Isabel',
		address: 'Av. Rivadavia 6044 - CABA ',
		logo: santaIsabel
	},
	clinicaDelSol: {
		name: 'Clínica del Sol',
		address: 'Av. Coronel Díaz 2211 - CABA',
		logo: clinicaDelSol
	},
	bazterrica: {
		name: 'Centro Médico Bazterrica',
		address: 'Tte. Gral. J. D. Perón 1739 - CABA',
		logo: bazterrica
	},
	santaRita: {
		name: 'Centro Médico Santa Rita',
		address: 'Blanco Encalada 158 - San Isidro',
		logo: santaRita
	},
	clinicaSantaIsabel: {
		name: 'Clínica Santa Isabel',
		address: 'Av. Directorio 2037 - CABA',
		logo: clinicaSantaIsabel
	},
	clinicaBazterrica: {
		name: 'Clínica Bazterrica',
		address: 'Billinghurst 2072 - CABA',
		logo: clinicaBazterrica
	}
}

export const IMAGING_STUDIES = [
	{
		slug: 'tomografia-sin-contraste',
		title: 'Tomografía sin contraste',
		description: '(peso máximo 140 kg)',
		subtitle: '(peso máximo 140 kg) Podés acercarte sin turno a:',
		centers: [
			{
				...CENTERS.santaIsabel,
				schedule: [
					'Lunes, martes, miércoles y viernes de 8:00 a 11:45 y de 15:00 a 19:45 hs',
					'Jueves de 15:00 a 19:45 hs'
				]
			},
			{
				...CENTERS.clinicaDelSol,
				schedule: ['Lunes a viernes de 8:30 a 19 hs.', 'Sábados de 8 a 12 hs']
			}
		]
	},
	{
		slug: 'radiografias',
		title: 'Radiografías',
		subtitle: 'Podés acercarte sin turno a:',
		centers: [
			{ ...CENTERS.bazterrica, schedule: ['Lunes a viernes de 8 a 19:30 hs'] },
			{ ...CENTERS.santaIsabel, schedule: ['Lunes a viernes de 8 a 19:30 hs'] },
			{
				...CENTERS.santaRita,
				schedule: [
					'Lunes a viernes de 8:30 a 13:30 y de 14:30 a 19:00 hs',
					'Sábados de 9 a 12:45 hs'
				]
			},
			{
				...CENTERS.clinicaDelSol,
				schedule: ['Lunes a viernes de 8 a 19:30 hs', 'Sábados de 8 a 12 hs']
			},
			{
				...CENTERS.clinicaSantaIsabel,
				schedule: ['Lunes a viernes de 8 a 20 hs', 'Sábados de 9 a 12:45 hs']
			},
			{
				...CENTERS.clinicaBazterrica,
				schedule: ['Lunes a domingo de 8 a 20:30 hs']
			}
		]
	},
	{
		slug: 'radiografias-panoramicas',
		title: 'Radiografías panorámicas',
		subtitle: 'Podés acercarte sin turno a:',
		centers: [
			{
				...CENTERS.santaRita,
				schedule: ['Lunes a viernes de 8:30 a 13:30 y de 14:30 a 19 hs.', 'Sábados de 9 a 12:45 hs']
			}
		]
	},
	{
		slug: 'ecografias',
		title: 'Ecografías',
		description: '(Excepto abdominales)',
		subtitle: '(Excepto abdominales) Podés acercarte sin turno a:',
		centers: [{ ...CENTERS.santaIsabel, schedule: ['Lunes a viernes de 8 a 19:00 hs'] }]
	},
	{
		slug: 'mamografias',
		title: 'Mamografías',
		subtitle: 'Podés acercarte sin turno a:',
		centers: [{ ...CENTERS.santaIsabel, schedule: ['Lunes a viernes de 8 a 19:30 hs'] }]
	}
]

export const getStudyBySlug = slug => IMAGING_STUDIES.find(study => study.slug === slug)
